import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { CheckCircle, ShieldCheck, Zap, Clock } from 'lucide-react';
interface PlanProDetailsProps {
  selectedPlan: number;
}
export function PlanProDetails({
  selectedPlan
}: PlanProDetailsProps) {
  const planDetails = [{
    title: '¿Qué incluye el Plan Base?',
    emoji: '📋',
    subtitle: '3 Módulos + 1 Bono',
    features: ['Módulo 1 – Historia Clínica Pediátrica Profesional', 'Módulo 2 – Desarrollo Infantil por Etapas', 'Módulo 3 – Protocolos de Consulta Pediátrica', 'Bono 1 – Kit de Señales de Alerta por Edad', 'Acceso de por vida'],
    showMostChosen: false
  }, {
    title: '¿Qué incluye el Plan PRO?',
    emoji: '✨',
    subtitle: 'Todo lo del Plan Base +',
    features: ['Módulo 4 – Comunicación con Padres y Familias', 'Módulo 5 – Derivaciones y Seguimiento Interdisciplinario', 'Bono 2 – Banco de Actividades de Estimulación Temprana', 'Bono 3 – Guía de Comunicación Difícil con Padres', 'Acceso de por vida + actualizaciones gratuitas'],
    showMostChosen: true
  }, {
    title: '¿Qué incluye la Biblioteca Completa?',
    emoji: '📚',
    subtitle: 'Todo lo del Plan PRO +',
    features: ['Los 5 Módulos completos', 'Los 3 Bonos exclusivos', 'Recursos extra de actualización continua', 'Plantillas editables premium', 'Acceso de por vida + actualizaciones prioritarias'],
    showMostChosen: false
  }];
  const currentPlan = planDetails[selectedPlan];
  return <section className="py-10 bg-white" data-id="element-98">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-99">
        <AnimatePresence mode="wait" data-id="element-100">
          <motion.div key={selectedPlan} initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={{
          opacity: 0,
          x: -20
        }} transition={{
          duration: 0.3
        }} className="bg-emerald-50 rounded-2xl p-6 md:p-8 border border-emerald-100 shadow-lg relative overflow-hidden" data-id="element-101">
            {/* Decorative background */}
            <div className="absolute top-0 right-0 w-64 h-64 bg-emerald-200 rounded-full blur-3xl opacity-20 transform translate-x-1/2 -translate-y-1/2" data-id="element-102"></div>

            <div className="relative z-10" data-id="element-103">
              <h3 className="text-xl md:text-2xl font-bold text-gray-900 mb-1 flex items-center gap-3" data-id="element-104">
                {currentPlan.title}{' '}
                <span className="text-xl" data-id="element-105">{currentPlan.emoji}</span>
              </h3>
              <p className="text-emerald-700 font-semibold mb-6" data-id="element-106">
                {currentPlan.subtitle}
              </p>

              <ul className="space-y-3 mb-6" data-id="element-107">
                {currentPlan.features.map((feature, index) => <li key={index} className="flex items-start gap-3" data-id="element-108">
                    <div className="bg-emerald-100 p-1 rounded-full flex-shrink-0 mt-0.5" data-id="element-109">
                      <CheckCircle className="w-4 h-4 text-emerald-600" data-id="element-110" />
                    </div>
                    <span className="text-gray-700 font-medium" data-id="element-111">{feature}</span>
                  </li>)}
              </ul>

              <div className="bg-white rounded-xl p-5 shadow-sm border border-emerald-50" data-id="element-112">
                {currentPlan.showMostChosen && <p className="text-center text-gray-800 font-bold mb-4 text-sm" data-id="element-113">
                    La opción más elegida por profesionales de la salud infantil
                  </p>}
                <div className="grid grid-cols-3 gap-4 text-center" data-id="element-114">
                  <div className="flex flex-col items-center gap-1.5" data-id="element-115">
                    <ShieldCheck className="w-7 h-7 text-emerald-500" data-id="element-116" />
                    <span className="text-xs font-medium text-gray-600" data-id="element-117">
                      Pago seguro
                    </span>
                  </div>
                  <div className="flex flex-col items-center gap-1.5" data-id="element-118">
                    <Zap className="w-7 h-7 text-emerald-500" data-id="element-119" />
                    <span className="text-xs font-medium text-gray-600" data-id="element-120">
                      Acceso inmediato
                    </span>
                  </div>
                  <div className="flex flex-col items-center gap-1.5" data-id="element-121">
                    <Clock className="w-7 h-7 text-emerald-500" data-id="element-122" />
                    <span className="text-xs font-medium text-gray-600" data-id="element-123">
                      Garantía 7 días
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </AnimatePresence>
      </div>
    </section>;
}